export default "/images/file.png?810bfc9f9055a6cdaf598b83c3121ea8";